<template>
  <div v-click-outside="close" class="click-outside" @mouseover.stop.prevent="onMouseOver" @mouseout.stop.prevent="onMouseOut">
    <mobile-main-nav
      v-if="!isDesktop"
      :background-styles="getBackground"
      :color-option="colorOption"
      :is-full-height="isFullHeight"
      :is-full-height-dark="isFullHeightDark"
      :is-office-open="isOfficeOpen"
      :office-phone-number="officePhoneNumber"
      :sections="sections"
      :current-section="currentSection"
    />

    <nav v-show="!isNavFixed" id="navigation-normal" ref="navbar" class="navbar" role="navigation" aria-label="main navigation" :style="getBackground">
      <div ref="navbarWrapper" class="container">
        <!-- DESKTOP -->
        <div v-if="isDesktop" class="navbar--main" :style="getBackground">
          <div class="navbar--main__start">
            <div :class="active ? 'navbar-search' : isFullHeight && isFullHeightDark ? 'navbar-search' : 'navbar-searchwhite'">
              <!-- Phone icon -->
              <div ref="navbarItemPhone" class="navbar-item navbar-icon navbar-item-custom-phone">
                <a v-if="isOfficeOpen" :href="`tel:${officePhoneNumber}`" alt="phone" class="navbar-item-custom-phone-number InfinityNumber clickable track-gtm-contact-phone" :class="{[`text-${colorOption}`]: true}">
                  <Phone :color="colorOption" class="navbar-item-custom-phone-icon" />
                  {{ officePhoneNumber }}
                </a>

                <!-- Callback icon -->
                <a v-if="!isOfficeOpen" @click="showModal">
                  <Callback :color="colorOption" class="navbar-item-custom-phone-icon callback" />
                  <span class="callBack__button" :class="{[`text-${colorOption}`]: true}">Book an initial call</span>
                </a>
              </div>
            </div>
            <a class="navbar-item navbar-icon navbar-item-enquiure" title="Send us an enquiry" aria-label="Send us an enquiry" href="/enquiries">
              <Mail v-if="isEnquiryPage === false" :color="colorOption" />
              <MailActive v-if="isEnquiryPage === true" :color="colorOption" />
            </a>
          </div>

          <!-- LOGO -->
          <a ref="navbarBrand" href="/" alt="TTT Logo" class="navbar--main__brand">
            <Logo size="large" :color="colorOption" />
          </a>

          <!-- Nav bar icons -->
            <!-- Shortlist icon and functionality -->
            <div ref="navbarItemShortlistIcon" class="navbar-icon navbar-mobile--icon shortlist" @click="openSection($event, sections.end.shortlist.name, sections.end.shortlist.id)">
              <Shortlist :expanded="currentSection === sections.end.shortlist.name" />
              <ShortlistCounter :color="colorOption" :isActive="currentSection === sections.end.shortlist.name" />
            </div>
        </div>

        <!-- NAV BAR DRAWER MENU -->
        <div v-if="isDesktop" class="navDrawers">
          <div v-if="isFullHeight" class="navDrawers--menu">
            <!-- <app-link id="16" type="page" class="navbar-item">
              <span class="navDrawers__title" :style="navColor">
                Search villas
              </span>
            </app-link> -->
            <a v-for="section in sections.start" :key="section.name" :ref="`navbarItem${removeWhitespace(section.ref)}`" class="navbar-item" :class="{'is-active': currentSection === section.name}" @click="toggleSection($event, section.name, section.id)">
              <span :class="{'navDrawers__title': true,
                             [`text-${colorOption}`]: true}"
              >
                {{ section.name }}
                <span v-if="currentSection === section.name" />
              </span>
            </a>
          </div>
          <div v-if="!isFullHeight" class="navDrawers--menu">
            <a v-for="section in sections.start" :key="section.name" :ref="`navbarItem${removeWhitespace(section.ref)}`" class="navbar-item" :class="{'is-active': currentSection === section.name}" @click="toggleSection($event, section.name, section.id)">
              <span class="navDrawers__title" style="color:#050817">
                {{ section.name }}
                <span v-if="currentSection === section.name" />
              </span>
            </a>
          </div>
        </div>
      </div>
    </nav>

    <!-- SCROLLED WINDOW NAV -->
    <nav v-show="isNavFixed" id="navigation-fixed" ref="navbar" :class="`navbar ${isNavFixed ? 'navbar-fixed' : ''}`" role="navigation" aria-label="main navigation">
      <div ref="navbarWrapper" class="container">
        <!-- FIXED DESKTOP NAV -->
        <div v-if="isDesktop" class="navbar--main" :style="getBackground">
          <div class="navbar--main__start">
             <!-- Phone icon -->
             <div ref="navbarItemPhone" class="navbar-item navbar-icon navbar-item-custom-phone">
              <a v-if="isOfficeOpen" :href="`tel:${officePhoneNumber}`" class="navbar-item-custom-phone-number InfinityNumber clickable track-gtm-contact-phone" alt="phone" :class="{[`text-${colorOption}`]: true}">
                <Phone :color="colorOption" class="navbar-item-custom-phone-icon" />
                {{ officePhoneNumber }}
              </a>

              <!-- Callback icon -->
              <a v-if="!isOfficeOpen" @click="showModal">
                <Callback :color="colorOption" class="navbar-item-custom-phone-icon callback" />
                <span class="callBack__button" :class="{[`text-${colorOption}`]: true}">Book an initial call</span>
              </a>
            </div>

            <a class="navbar-item navbar-icon navbar-item-enquiure" title="Send us an enquiry" href="/enquiries">
              <Mail v-if="isEnquiryPage === false" :color="colorOption" />
              <MailActive v-if="isEnquiryPage === true" :color="colorOption" />
            </a>
          </div>

          <!-- TTT LOGO -->
          <a ref="navbarBrand" href="/" alt="TTT Logo" class="navbar--main__brand">
            <Logo />
          </a>

          <!-- Nav bar icons -->
            <!-- Shortlist icon and functionality -->
            <div ref="navbarItemShortlistIcon" class="navbar-icon navbar-mobile--icon shortlist" @click="openSection($event, sections.end.shortlist.name, sections.end.shortlist.id)">
              <Shortlist :expanded="currentSection === sections.end.shortlist.name" />
              <ShortlistCounter :color="colorOption" :isActive="currentSection === sections.end.shortlist.name" />
            </div>
          </div>
      </div>
    </nav>

    <tab-drawer :id="sections.start.findVillas.name" :pos="'full'" :expanded="currentSection === sections.start.findVillas.name" class="drawer" :class="`${isNavFixed ? 'navbar-drawer-fixed' : ''}`">
      <tab-find-villas ref="findVillas"
                       :text-arrival="textArrival"
                       :text-departure="textDeparture"
                       :text-destination-label="textDestinationLabel"
                       :text-find-villas="textFindVillas"
                       :region="region"
                       section="nav"
      />
    </tab-drawer>
    <tab-drawer :id="sections.start.regions.name" :pos="'full'" :expanded="currentSection === sections.start.regions.name" class="drawer" :class="`${isNavFixed ? 'navbar-drawer-fixed' : ''}`">
      <tab-destinations />
    </tab-drawer>

    <tab-drawer :id="sections.start.availability.name" :pos="'full'" :expanded="currentSection === sections.start.availability.name" class="drawer" :class="`${isNavFixed ? 'navbar-drawer-fixed' : ''}`">
      <tab-inspiration ref="availability" />
    </tab-drawer>

    <tab-drawer :id="sections.start.experiences.name" :pos="'full'" :expanded="currentSection === sections.start.experiences.name" class="drawer" :class="`${isNavFixed ? 'navbar-drawer-fixed' : ''}`">
      <tab-experiences ref="experiences" />
    </tab-drawer>

    <tab-drawer :id="sections.start.aboutUs.name" :pos="'full'" :expanded="currentSection === sections.start.aboutUs.name" class="drawer" :class="`${isNavFixed ? 'navbar-drawer-fixed' : ''}`">
      <tab-aboutUs ref="aboutUs" />
    </tab-drawer>

    <tab-drawer :id="sections.end.hamburgernav.name" :pos="'full'" :expanded="currentSection === sections.end.hamburgernav.name" class="drawer" :class="`${isNavFixed ? 'navbar-drawer-fixed' : 'navbar-drawer-large'}`">
      <!-- <tab-hamburger /> -->
      <DesktopHamburgerMenu />
    </tab-drawer>

    <tab-drawer :id="sections.end.search.name" :pos="'full'" :expanded="currentSection === sections.end.search.name" class="drawer" :class="`${isNavFixed ? 'navbar-drawer-fixed navbar-drawer-algolia' : 'navbar-drawer-large navbar-drawer-algolia'}`">
      <div class="navbar-search-back" @click.prevent="closeTab">
        <font-awesome-icon icon="caret-left" aria-label="left arrow" />&nbsp;Back
      </div>
    </tab-drawer>

    <!-- Modal for Call back button for when office is closed - should not be placed inside any nav containers -->
    <modal v-show="isModalVisible" class="callback__modal" @close="closeModal">
      <div slot="content" class="callback__modal--content">
        <iframe loading="lazy" title="Book an initial call" width="100%" height="100%" src="https://bookings.thethinkingtraveller.com/portal-embed#/customer/callbacks" frameborder="0" allowfullscreen="" />
      </div>
    </modal>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';
import Logo from '../icons/logo';
import Phone from '../icons/Phone';
import Callback from '../icons/Callback';
import Mail from '../icons/Mail';
import MailActive from '../icons/MailActive';
import Hamburger from '../icons/Hamburger';
import Cross from '../icons/Cross';
import Search from '../icons/Search';
// import LoginIcon from './Icons/IconLogin';
import TabDrawer from './Tabs/TabDrawer';
import DesktopHamburgerMenu from './Tabs/DesktopHamburgerMenu.vue';
import MobileMainNav from './MobileMainNav.vue';
import TabFindVillas from './Tabs/TabFindvillas';
import TabDestinations from './Tabs/TabDestinations';
import TabInspiration from './Tabs/TabInspiration';
import TabExperiences from './Tabs/TabExperiences';
import TabAboutUs from './Tabs/TabAboutUs';
import Shortlist from './Shortlist/Shortlist';
import ShortlistCounter from './Shortlist/ShortlistCounter.vue';
import translateUrl from '../../mixins/translateUrl';
import sticky from '../../mixins/sticky';
import closeTab from '../../mixins/closeTab';
import infinityNumberReplace from '../../mixins/infinityNumberReplace';
import responsive from '../../mixins/responsive';
import Modal from '../Modal.vue';
import Bus from '../../events/bus';
import Suggestions from './AlgoliaSearch/Suggestions.vue';
// import languageSelector from '../languageSelector.vue';

export default {
  components: {
    Logo,
    Phone,
    Callback,
    Mail,
    MailActive,
    Hamburger,
    Cross,
    Search,
    TabDrawer,
    TabFindVillas,
    TabDestinations,
    TabInspiration,
    TabExperiences,
    TabAboutUs,
    DesktopHamburgerMenu,
    MobileMainNav,
    Shortlist,
    ShortlistCounter,
    Modal,
    Suggestions,
    // languageSelector,
  },
  directives: {
    ClickOutside,
  },
  mixins: [translateUrl, sticky, closeTab, infinityNumberReplace, responsive],
  props: {
    textArrival: {
      type: String,
      required: false,
    },
    textDeparture: {
      type: String,
      required: false,
    },
    textDestinationLabel: {
      type: String,
      required: false,
    },
    region: {
      type: String,
    },
    textFindVillas: {
      type: String,
      required: false,
    },
    section: {
      type: String,
    },
  },
  data() {
    return {
      isModalVisible: false,
      // Navigation sections. Each 'name' key is used to correctly set section open/closed state.
      sections: {
        start: {
          findVillas: {
            id: 1,
            name: 'Search villas',
            ref: 'findvillas',
          },
          regions: {
            id: 2,
            name: 'Destinations',
            ref: 'destinations',
          },
          experiences: {
            id: 8,
            name: 'Experiences',
            ref: 'experiences',
          },
          availability: {
            id: 7,
            name: 'Inspiration',
            ref: 'availability',
          },
          aboutUs: {
            id: 9,
            name: 'About us',
            ref: 'aboutUs',
          },
        },
        end: {
          search: {
            id: 3,
            name: 'Search',
          },
          shortlist: {
            id: 4,
            name: 'Shortlist',
          },
          hamburgernav: {
            id: 5,
            name: 'Hamburgernav',
          },
        },
      },
      mobile: {
        sections: {
          start: {
            menu: {
              id: 6,
              name: 'Menumobile',
            },
          },
        },
      },
      searchQuery: null,
      active: false,
      clickedFromOutsideMain: false,
    };
  },
  computed: {
    currentSection() {
      return this.$store.getters['common/getCurrentSection'];
    },
    screenType() {
      return this.$store.getters['common/getScreenType'];
    },
    isOfficeOpen() {
      return this.$store.getters['common/getOfficeStatus'].officeStatus === 'OPEN NOW';
    },
    officePhoneNumber() {
      return this.$store.getters['common/getOfficeStatus'].officeNumber_InfinityTrackFriendly;
    },
    isMobileMenuActive() {
      return this.currentSection === this.mobile.sections.start.menu.name;
    },
    isFullHeight() {
      return this.$store.getters['pages/currentPage'] ? [3, 65, 24, 17, 26, 97].includes(this.$store.getters['pages/currentPage'].templateId) : false;
    },
    isFullHeightDark() {
      return this.$store.getters['pages/currentPage'] ? [97].includes(this.$store.getters['pages/currentPage'].templateId) : false;
    },
    isNavFixed() {
      return this.$store.getters['common/getNavfixed'];
    },
    navColor() {
      if (this.active || this.isFullHeightDark) {
        return 'dark';
      }

      if (this.isFullHeight) {
        return 'light';
      }

      return 'dark';
    },
    getBackground() {
      return {
        background: this.active ? '#FEFCFA' : 'transparent',
        borderBottom: this.active ? '1px solid #EBE4D1' : '1px solid rgba(254, 252, 250, .1)',
      };
    },
    getBorderColor() {
      return {
        borderLeft: this.active ? '1px solid #EBE4D1' : '1px solid rgba(254, 252, 250, .1)',
      };
    },
    colorOption() {
      return this.isMobileMenuActive || this.active || this.isNavFixed || this.isFullHeightDark || this.currentSection === 'Shortlist'
        ? 'dark'
        : this.isFullHeight
          ? 'light'
          : 'dark';
    },
    isResultsPage() {
      return this.$store.getters['pages/currentPage'] ? this.$store.getters['pages/currentPage'].templateId == 5 : false;
    },
    isEnquiryPage() {
      return this.$store.getters['pages/currentPage'] ? this.$store.getters['pages/currentPage'].id == 41 || this.$store.getters['pages/currentPage'].id == 43 : false;
    },
    isShortlistEmpty() {
      return this.$store.getters['common/getShortlist'].length === 0;
    },
    currentRedirectSection() {
      return this.$store.getters['common/getCurrentRedirectSection'];
    },
  },
  watch: {
    isNavFixed: {
      handler(val) {
        if (this.isFullHeight) {
          this.active = val;
        }
        else {
          this.active = true;
        }
      },
      immediate: false,
      deep: true,
    },
    isResultsPage: {
      handler(val) {
        if (val) {
          this.active = true;
        }
      },
      immediate: true,
      deep: true,
    },
    isFullHeight: {
      handler(val) {
        if (val) {
          this.active = false;
        }
      },
      immediate: true,
      deep: true,
    },
    currentSection(val) {
      if (this.isFullHeight && val === '') {
        this.active = false;
      }
      else if (this.isFullHeight && val !== '') {
        this.active = true;
      }
      Bus.$emit('closeDatePicker');
    },
  },
  created() {
    this.$store.dispatch('common/getOfficeHours', this.getOfficePayload());
    this.updateEnquiry();
    this.resetEnquiry();
  },
  // updated() {
  // Commented out on 13/06/22 as phone number now hard coded in nav
  // prepend +44 to the ROW number replaced by infinity (infinity number does not include)
  // const numberTag = document.querySelector('.main-nav-row');
  // if (numberTag) {
  //   this.ObserveInfinityNumberTag(numberTag, true); // import infinityNumberReplace
  // }

  // const numberTag2 = document.querySelector('.main-nav-row-2');
  // if (numberTag2) {
  //   this.ObserveInfinityNumberTag(numberTag2, false); // import infinityNumberReplace
  // }

  // const numberTag3 = document.querySelector('.main-nav-row-3');
  // if (numberTag3) {
  //   this.ObserveInfinityNumberTag(numberTag3, false); // import infinityNumberReplace
  // }

  // const numberTag4 = document.querySelector('.main-nav-row-4');
  // if (numberTag4) {
  //   this.ObserveInfinityNumberTag(numberTag4, true); // import infinityNumberReplace
  // }
  // },
  mounted() {
    this.checkToken();
    this.setShortlistMobileWidth();
    Bus.$on('openShortlist', this.openSectionFromBanner);
  },
  beforeDestroy() {
    Bus.$off('openShortlist', this.openSectionFromBanner);
  },
  methods: {
    close() {
      if (!this.clickedFromOutsideMain) this.closeTab();
    },
    checkToken() {
      if (sessionStorage.getItem('auth_token')) {
        this.$store.commit('common/setToken', sessionStorage.getItem('auth_token'));
      }
    },
    setShortlistMobileWidth() {
      const hamburgerIconWidth = this.$refs.navbarItemHamburgerIcon ? this.$refs.navbarItemHamburgerIcon.clientWidth : 0;
      const shortlistWidth = Math.round(window.screen.width - hamburgerIconWidth);
      this.$store.commit('common/setShortlistWidth', shortlistWidth);
    },
    removeWhitespace(str) {
      return str.replace(/\s+/g, '');
    },
    toggleSection(ev, sectionName, sectionId) {
      if (this.currentSection === sectionName) {
        if (!sectionName === 'Menumobile') {
          this.$store.commit('common/showOverlay', true);
        }
        this.$store.commit('common/closeSection', '');
        this.closeTab(ev);
      } else {
        if (!sectionName === 'Menumobile') {
          this.$store.commit('common/showOverlay', true);
          document.body.classList.add('modal-open');
        }
        this.closeTab(ev);
        this.$store.commit('common/openSection', sectionName);
        this.$store.commit('common/showOverlay', true);
        this.$store.commit('common/setSearchwide', false);
        document.body.classList.add('modal-open');
      }
    },
    openSectionFromBanner(val) {
      this.openSection(val, this.sections.end.shortlist.name, this.sections.end.shortlist.id);
      // Hack to get around ClickOutside
      this.clickedFromOutsideMain = true;
      setTimeout(() => {
        this.clickedFromOutsideMain = false;
      }, 100);
    },
    openSection(ev, sectionName, sectionId) {
      if (sectionName === 'Menumobile' || sectionName === 'Search') {
        this.$store.commit('common/openSection', sectionName);
        this.$store.commit('common/openMobileSection', 0);
        this.$store.commit('common/showOverlay', true);
        document.body.classList.add('modal-open');
      } else {
        if (this.currentSection !== sectionName) {
          this.$store.commit('common/openSection', sectionName);
          this.$store.commit('common/showOverlay', true);
          this.$store.commit('common/setSearchwide', false);
          document.body.classList.add('modal-open');
        } else {
          this.closeTab(ev);
        }
      }
    },
    getOfficePayload() {
      const currDate = new Date();
      const officePayload = {
        timezone: currDate.getTimezoneOffset(),
      };
      return officePayload;
    },
    resetSearchQuery() {
      this.searchQuery = '';
      this.$store.commit('common/closeSection', '');
      this.closeTab(null);
    },
    onMouseOver() {
      if (this.isFullHeight) {
        this.active = true;
      }
    },
    onMouseOut() {
      if (this.isFullHeight) {
        this.active = this.isNavFixed || this.currentSection !== '';
      }
      else {
        this.active = true;
      }
    },
    redirectTo(pagename) {
      this.closeTab(null);
      this.isShortlistEmpty ? this.$router.push({ path: this.$store.getters['applinks/getLink']('page', 43).url }) : this.$router.push({ path: this.$store.getters['applinks/getLink']('page', 41).url });
      window.scrollTo(0, 0);
      // does not seem like we need these
      this.$store.commit('common/setCurrentRedirectSection', pagename);
      window.$cookies.set('currentRedirectSection', 'enquiry', 2147483647);
    },
    updateEnquiry() {
      // update
      if (/enquiry|demande|anfrage|my-enquiry-list|ma-selection|meine-anfrageliste/.test(window.location.href)) {
        this.$store.commit('common/setCurrentRedirectSection', 'enquiry');
      }
    },
    resetEnquiry() {
      // reset
      if (!/enquiry|demande|anfrage|my-enquiry-list|ma-selection|meine-anfrageliste/.test(window.location.href) && window.$cookies.get('currentRedirectSection')) {
        window.$cookies.set('currentRedirectSection', '', 2147483647);
      }
    },
    showModal(e) {
      this.isModalVisible = true;
      e.preventDefault();
      document.body.classList.add('modal-open');
    },
    closeModal() {
      this.isModalVisible = false;
      document.body.classList.remove('modal-open');
    },
  },
};
</script>

<style lang="scss">

@import "../../assets/styles/settings/config.scss";

$bgtransition : background 0.3s;

.click-outside {
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 1000;
}

.shortlist {
  display: flex;
  justify-content: end;
  align-items: center;
}

// DEFAULT STYLES AND NAVBAR NOT FIXED
.navbar {
  background: $stoneWhite;
  transition: $bgtransition;
  font-size: 14px;
  &-icon {
    cursor: pointer;
  }
  &--main {
    height: 72px;
    grid-gap: 1em;
    padding: 0 24px;
    display: grid;
    grid-template-columns: 1fr auto 1fr;

    &__start {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    &__brand {
      display: flex;
      justify-content: center;
      align-items: center;
      .logo {
        width: 272px;
        height: 32px;
      }
    }
    &__end {
      display: grid;
      grid-template-columns: auto 20px 20px 72px;
      width: fit-content;
      grid-gap: 1.5em;
      align-items: center;
      width: 300px;
    }
  }
  &-mobile {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    height: 56px;
  }
  &-search,
  &-searchwhite {
cursor: pointer;
input {
      cursor: text;
      border: 0;
      min-width: 230px;
      // added a white border to avoid input jumping on focus
      border-bottom: 2px solid transparent;
      background: none;
      background-repeat: no-repeat;
      background-position-y: center;
      padding-left: 30px;
      text-overflow: ellipsis;
      @media (max-width: 768px) and (orientation: portrait) {
        min-width: 260px;
        width: 70%;
        background-position-y: initial;
      }
      @media (max-width: 480px) and (orientation: portrait){
        min-width: 200px;
        width: 80%;
      }
      @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
       min-width: 240px;
       width: 90%;
      }
      @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
       min-width: 300px;
       width: 80%;
      }
      // @media (min-width: 1025px) {
      //   width: 290px;
      // }

      &:not(output):-moz-ui-invalid {
        box-shadow: none !important;
      }

      &:not(output):-moz-ui-invalid:-moz-focusring {
       box-shadow: none !important;
      }

      &:focus {
        border-bottom: 2px solid #050817;
        padding-left: 30px;
        @media (max-width: 768px) {
          background-position-y: initial;
        }

      }
      &::placeholder {
        color: $darkBlack;
      }
      @media (max-width: 768px) {
        border-bottom: 2px solid #f7f9fb;
        margin: 0 1em;
      }
    }
    @media (max-width: 768px) {
      height: 56px;
      border-bottom: 2px solid $stoneDisabled;
    }
    &-back {
      height: 30px;
      color: $echo-blue;
      font-weight: 500;
      padding: 0 1em;
      margin-bottom: 1em;
      display: flex;
      align-items: center;
      &-icon {
        width: 7px;
        height: 9px;
        background-color: #a1abc5;
        display: inline;
      }
    }
  }
  &-searchwhite {
    input {
      color: white;
      &::placeholder {
        color: white;
      }
    }
  }
}

.search__form {
  position: relative;
  margin: 24px 24px 0 24px;
    &--input {
      width: 100%;
    }
  &__icon {
    position: absolute;
    top: 16px;
    right: 16px;
  }
}

@media (min-width: 1026px) {
  .navbar-search-back,
  .navbar-searchwhite-back {
    display: none;
  }
}

.navbar-fixed {
  position: fixed;
  width: 100%;
  .navbar {
    &--main {
    height: 50px;
    margin-right: calc(-1 * (100vw - 100%)) !important;
  }
    &-search{
      padding: 0px 0px 0px 10px;
    }
  }
}

.navbar-item-custom-phone-number {
  display: flex;
  align-items: center;
  padding-left: 15px;
}

.navbar-item-enquiure {
  padding-left: 15px;
}

// Nav drawers to display tab drawers on desktop only
 .navbar-drawer {
    box-shadow: 0;
    &-fixed {
      position: fixed;
      width: 100%;
      // top = height of .navbar-fixed
      top: 50px;
      @media (max-width: 900px) {
        top: 0;
      }

    }
    &-large {
      // Used for search/results drawer to cover navDrawer height of 40px
      margin-top: -40px;
      z-index: 33;
      position: relative;
      @media (max-width: 768px) {
        // Used for search/results drawer to cover covid bar and mobile nav 56px+56px
        margin-top: -112px;
      }
    }
  }

.navDrawers {
  &--menu {
    display: flex;
    justify-content: center;
    height: 40px;
    margin: 0 auto;
    align-items: center;
  }
  a.navbar-item:hover {
    cursor: pointer;
  }
  &__title {
    text-transform: uppercase;
    color: $darkBlack;
    font-weight: 400;
    padding: 0 3em;
    letter-spacing: 0.07em;
    @media (max-width: 1200px) {
      padding: 0 2em;
    }

    &--light {
      color: $white;
    }
  }
}

.navbar-item {
  cursor: pointer;
  &.is-active {
    .navDrawers__title {
      font-weight: 500;
    }
  }
}

.navbar {
  &-item {
    &-custom {
      &-phone {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        line-height: 1;
        stroke-width: 1;
        &-number {
          color: $darkBlack;
        }
        &-office-status {
          color: $grey;
          font-size: 13px;
          line-height: 1;
        }
        // &-icon {
        //   height: 20px;
        //   position: absolute;
        //   left: -15px;
        //   height: 23px;
        //   top: -5px;
        //   &.callback {
        //     left: -22px;
        //   }
        // }
      }
    }
  }

  .homenav-icon {
    margin-top: 2px;
  }

  // .phone-icon {
  //   height: 19px;
  //   color: $darkBlack;
  //   svg {
  //     stroke-width: 1;
  //   }
  // }
  // .loginIcon {
  //   height: 20px;
  // }
}

.navbar-search-box, .navbar-search,
.navbar-searchwhite-box, .navbar-searchwhite {
	position: relative;
  @media (max-width: 768px) {
    padding: 0;
  }
}

// display 'X' button on Algolia search upon typing
.navbar-search-box:not(:valid) ~ .close-search {
	display: none;
}
.navbar-searchwhite-box:not(:valid) ~ .close-search {
	display: none;
}

// .isDesktop {
//  @media (max-width: 900px) {
//     display: none;
//   }
// }

.isNotDesktop {
 @media (min-width: 901px) {
    display: none;
  }
}

.callback {
  &__button {
    cursor: pointer;
  }
  &__modal--content {
    height: 60vh;
    @include mobile-down {
      height: 100%;
    }
  }
}

.callback__modal::v-deep {
  .modal {
    width: 566px !important;
  }
}

.hamburger {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.search-form {
  display: flex;
}

.search-icon-fixed {
  position: absolute;
  top: 22px;
}

.search-icon-scroll {
cursor: pointer;
position: absolute;
  top: 13px;
}
input:focus {
    background-color: initial !important;
}
</style>
